import { Head } from "@inertiajs/react"
import { SonarLayout } from "@/components/sonar"
import { ProfitLoss, type ProfitLossData } from "@/components/profit-loss"

interface ProfitLossPageProps {
  report: ProfitLossData
}

export default function ProfitLossPage({ report }: ProfitLossPageProps) {
  return (
    <>
      <Head title="Profit & Loss">
        <meta
          name="description"
          content="Monthly profit & loss by entity — income, COGS, operating and other expenses, gross, operating and net profit with margins. Toggle Spain / US / Consolidated (€)."
        />
        <meta property="og:title" content="Profit & Loss" />
        <meta
          property="og:description"
          content="Monthly profit & loss by entity — income, COGS, operating and other expenses, gross, operating and net profit with margins. Toggle Spain / US / Consolidated (€)."
        />
      </Head>
      <SonarLayout>
        <ProfitLoss report={report} />
      </SonarLayout>
    </>
  )
}
